// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./product-list/image-slider/styles.scss
// module id = 944
// module chunks = 0